import { useEffect, useState } from 'react';
import { fetchCalendarConnection } from '../api';

export const useCalendarConnection = () => {
  const [isCalendarConnected, setIsCalendarConnected] = useState(false);

  useEffect(() => {
    let mounted = true;

    const loadCalendarConnection = async () => {
      try {
        const connection = await fetchCalendarConnection();
        if (mounted === false) return;

        setIsCalendarConnected(connection.googleCalendarConnected);
      } catch {
        if (mounted === false) return;

        setIsCalendarConnected(false);
      }
    };

    loadCalendarConnection();

    return () => {
      mounted = false;
    };
  }, []);

  return { isCalendarConnected };
};
